const state = {
  customer: {
    settingsCompanyTypeOptions: [
      {
        text: "Fleet",
        value: "fleet"
      },
      {
        text: "Maintainer",
        value: "mainteiner"
      },
      {
        text: "Reseller",
        value: "reseller"
      }
    ],
    categoryOptions: [
      {
        text: "Beveiliging",
        value: "beveiliging"
      },
      {
        text: "Bezorgdiensten",
        value: "bezorgdiensten"
      },
      {
        text: "Bouwbedrijven",
        value: "bouwbedrijven"
      },
      {
        text: "Dakbedekking",
        value: "dakbedekking"
      },
      {
        text: "Distributie",
        value: "distributie"
      },
      {
        text: "Elektriciens",
        value: "elektriciens"
      },
      {
        text: "Elektrotechniek",
        value: "elektrotechniek"
      },
      {
        text: "Facilitaire dienst",
        value: "facilitaire_dienst"
      },
      {
        text: "Freelancer",
        value: "freelancer"
      },
      {
        text: "Gemeente",
        value: "gemeente"
      },
      {
        text: "Goederenvervoer",
        value: "goederenvervoer"
      },
      {
        text: "Groothandel",
        value: "groothandel"
      },
      {
        text: "Hoveniers",
        value: "hoveniers"
      },
      {
        text: "Installateurs",
        value: "installateurs"
      },
      {
        text: "Logistiek",
        value: "logistiek"
      },
      {
        text: "Loodgieters",
        value: "loodgieters"
      },
      {
        text: "Luchtbehandeling",
        value: "luchtbehandeling"
      },
      {
        text: "Overheid",
        value: "overheid"
      },
      {
        text: "Personenvervoer",
        value: "personenvervoer"
      },
      {
        text: "Schilders",
        value: "schilders"
      },
      {
        text: "Schoonmaakbedrijf",
        value: "schoonmaakbedrijf"
      },
      {
        text: "Staalbewerking",
        value: "staalbewerking"
      },
      {
        text: "Taxi",
        value: "taxi"
      },
      {
        text: "Transport",
        value: "transport"
      },
      {
        text: "Uitzendbureau",
        value: "uitzendbureau"
      },
      {
        text: "Verhuisvervoer",
        value: "verhuisvervoer"
      },
      {
        text: "Verlichting",
        value: "verlichting"
      },
      {
        text: "Vewarming",
        value: "vewarming"
      },
      {
        text: "Vrachtvervoer",
        value: "vrachtvervoer"
      },
      {
        text: "Wegenbouw",
        value: "wegenbouw"
      },
      {
        text: "Other",
        value: "other"
      }
    ],
    uluCategoryOptioins: [
      {
        text: "Dealerships",
        value: "dealerships"
      },
      {
        text: "Insurance",
        value: "insurance"
      },
      {
        text: "Leasing",
        value: "leasing"
      },
      {
        text: "Tech company",
        value: "tech_company"
      },
      {
        text: "Other",
        value: "other"
      }
    ],
    sourceOptions: [
      {
        text: "Cold Calling",
        value: "cold_calling"
      },
      {
        text: "Dummy Dongel",
        value: "dummy_dongel"
      },
      {
        text: "Event",
        value: "event"
      },
      {
        text: "Expertmarket",
        value: "expertmarket"
      },
      {
        text: "Netwerk",
        value: "netwerk"
      },
      {
        text: "Website",
        value: "website"
      },
      {
        text: "Other",
        value: "other"
      }
    ]
  },
  items: {
    kpiTypesOptions: [
      {
        text: "VELPRO sold",
        value: "velpro_sold"
      },
      {
        text: "VELPRO lease",
        value: "velpro_lease"
      },
      {
        text: "VEL10 sold",
        value: "vel10_sold"
      },
      {
        text: "VEL10 lease",
        value: "vel10_lease"
      },
      {
        text: "Connectivity",
        value: "connectivity"
      },
      {
        text: "Installation",
        value: "installation"
      },
      {
        text: "VELPRO extra'ss (buzzers etc. )",
        value: "velpro_extra"
      },
      {
        text: "Cables",
        value: "cables"
      },
      {
        text: "Other",
        value: "other"
      }
    ]
  },
  brandOptions: [
    {
      text: "ULU",
      value: "ulu"
    },
    {
      text: "ULU B.V.",
      value: "ulubv"
    },
    {
      text: "ULU Technologies UK",
      value: "uluuk"
    },
    {
      text: "Fleetify",
      value: "fleetify"
    },
    {
      text: "Cartracker",
      value: "cartracker"
    },
    {
      text: "Traksi",
      value: "traksi"
    },
    {
      text: "Requre",
      value: "requre"
    },
    {
      text: "Finnik",
      value: "finnik"
    },
    {
      text: "National netherlands",
      value: "national_netherlands"
    },
    {
      text: "iMoto",
      value: "imoto"
    }
  ],
  enumeratorsOptions: [
    {
      label: 'Customers',
      options: [
        {
          text: "Customer category",
          value: "customer_category"
        },
        {
          text: "Customer source",
          value: "customer_source"
        },
      ]
    },
    {
      label: 'Inquiries',
      options: [
        {
          text: "Inquiry lost reason",
          value: "inquiry_lost_reason"
        }
      ]
    },
    {
      label: 'KPI',
      options: [
        {
          text: "KPI type",
          value: "kpi_type"
        }
      ]
    },
    {
      label: 'Services',
      options: [
        {
          text: "Service replace reason",
          value: "service_replace_reason"
        },
        {
          text: "Service call reason",
          value: "service_call_reason"
        }
      ]
    },
    {
      label: 'Orders',
      options: [
        {
          text: "Order termination reason",
          value: "order_termination_reason"
        }
      ]
    }
  ],
  currencyOptions: ["EUR", "GBP", "USD"]
};

const getters = {
  getEnumTypeOptions(state) {
    return state.enumeratorsOptions;
  },
  getCustomerCategoryOptions(state, getters, rootState, rootGetters) {
    let brand = rootGetters.getUserSystem.toLowerCase();
    if (brand == "ulu") {
      return state.customer.uluCategoryOptioins;
    } else {
      return state.customer.categoryOptions;
    }
  },
  getCustomerSourceOptions(state) {
    return state.customer.sourceOptions;
  },
  getCustomerSettingsCompanyTypeOptions(state) {
    return state.customer.settingsCompanyTypeOptions;
  },
  getItemKpiTypesOptions(state) {
    return state.items.kpiTypesOptions;
  },
  getBrandOptions(state) {
    return state.brandOptions;
  },
  getCurrencyOptions(state) {
    return state.currencyOptions;
  }
};

const actions = {
  fetchActiveEnums({ dispatch }, payload) {

    return new Promise((resolve, reject) => {
      let fetchPayload = {
        this_ref: payload.this_ref,
        data: {
          query: "query {"
        }
      };

      payload.enums.forEach(enumType => {
        fetchPayload.data.query += `
          ${enumType}: enumsTypeActive (enum_type: "${enumType}") {
            text: name
            value
          }
        `
      });

      fetchPayload.data.query += "}"
    
      dispatch("axios_mod/simpleFetch", fetchPayload, { root: true }).then((res) => {
        resolve(res);
      });
    })
  },
  fetchAllEnums({ dispatch }, payload) {

    return new Promise((resolve, reject) => {
      let fetchPayload = {
        this_ref: payload.this_ref,
        data: {
          query: "query {"
        }
      };

      payload.enums.forEach(enumType => {
        fetchPayload.data.query += `
          ${enumType}: enumsAll (enum_type: "${enumType}") {
            text: name
            value
            disabled
          }
        `
      });

      fetchPayload.data.query += "}"
    
      dispatch("axios_mod/simpleFetch", fetchPayload, { root: true }).then((res) => {
        resolve(res);
      });
    })
  }  
}

export default {
  namespaced: true,
  state,
  getters,
  actions
};
